export default __webpack_public_path__ + "static/media/flower.5c55d608.png";